/**
 * Translation reducers script file
 *
 * @package    Reducers
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import Immutable from 'seamless-immutable';

import {
    SET_LOCALE,
} from 'Actions/general';
import {
    DEFAULT_LANGUAGE,
    LANGUAGES,
} from 'Constants/general';

export const INITIAL_STATE = Immutable({
    languages: LANGUAGES,
    locale: DEFAULT_LANGUAGE,
});

export default function translationsReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_LOCALE:
            return state.merge({
                locale: action.locale,
            });

        default:
            return state;
    }
}
